module.exports = __webpack_public_path__ + "img/evaluation_banner.26ba4df5.jpg";